import partnerClient from "../partnerClient";

export const fetchPartnerTasks = async (params) => {
  const { data } = await partnerClient.get("/tasks", { params });
  return data?.data ?? data;
};

export const updatePartnerTaskStatus = async ({ taskId, status }) => {
  const { data } = await partnerClient.patch(`/tasks/${taskId}/status`, { status });
  return data?.data ?? data;
};

export const fetchPartnerTask = async (taskId) => {
  const { data } = await partnerClient.get(`/tasks/${taskId}`);
  return data?.data ?? data;
};

export const postPartnerTaskComment = async ({ taskId, text }) => {
  const { data } = await partnerClient.post(`/tasks/${taskId}/comments`, { text });
  return data?.data ?? data;
};

export const setPartnerSubtaskCompleted = async ({ taskId, subtaskId, completed }) => {
  const { data } = await partnerClient.patch(`/tasks/${taskId}/subtasks/${subtaskId}`, {
    completed,
  });
  return data?.data ?? data;
};
